
import { Subscription, map, switchMap } from "rxjs";
import { createUpdator, watcher, editing$, get, obsIsAdmin } from "../seo";
import { isPossiblyAdminUser } from "./auth";

export type Options = {
	saveFormatter: (value:any) => any,
	mayEdit?: (prop:string, value:any) => boolean,
	onEdited?: (value:string|number, prop:string) => void
}

export type Editor = (currentValue: string | number) => Promise<string | number | undefined> | undefined;
type SaveFormatter = (value: any) => any;

export function createTextEditorAction(collection:string, docId:string, saveFormatter = (value:any) => value, mayEdit?: (prop:string, value:any) => boolean, onEdited?:(value:string|number, prop:string) => void) {
	const updator = createUpdator(collection, docId);
	const updates$ = watcher(collection, docId);
	const contentPromise = get(collection, docId);
	return (node: HTMLElement, [prop, editor]: [string, Editor?]) => {
		let currentValue: string | number;

		const update = async (prop:string, value:any) => {
			currentValue = saveFormatter(value);
			await updator(prop, currentValue);
			onEdited?.(currentValue, prop);
		};

		const onActivate = () => {
			if (editor) {
				node.onclick = (e) => {
					if (mayEdit && !mayEdit(prop, currentValue)) return;
					e.preventDefault(); // don't follow the link
					e.stopPropagation(); // don't go to parent's click event
					editor?.(currentValue)?.then(value => typeof value === 'undefined' ? undefined : update(prop, value));
				}
			} else {
				if (mayEdit && !mayEdit(prop, currentValue)) return;
				if (node.contentEditable === 'true') return;
				node.contentEditable = 'true';
				node.onblur = (e) => update(prop, node.innerText);
			}
			
		};
		const onDeactivate = () => {
			if (editor) {
				node.onclick = null;
			} else {
				if (node.contentEditable === 'false') return;
				node.contentEditable = 'false';
				node.onblur = null;
			}
		}
	
		const sub = editing$.subscribe(editing => {
			if (editing) {
				onActivate();
			} else {
				onDeactivate();
			}
		});
	
		let subFirestore: Subscription;
		if (isPossiblyAdminUser()) { // avoid setting up firebase overhead at all cost
			const $ = obsIsAdmin().pipe(
				switchMap(isAdmin => isAdmin ? updates$.pipe(map(([,doc]) => doc?.[prop])) : contentPromise.then(c => c?.[1]?.[prop])),
			)
			subFirestore = $.subscribe(value => {
				node.innerText = value ?? '[not set]';
			});
		}
		
		// if not set then do so
		contentPromise.then(c => {
			currentValue = c?.[1]?.[prop] ?? '[not set]';
			if (node.innerText !== currentValue) node.innerText = currentValue.toString();
		});

		return {
			destroy() {
				sub.unsubscribe();
				subFirestore?.unsubscribe();
				onDeactivate();
			},
			// update([prop, editor]: [string, Editor?]) {

			// }
		};
	}
}
